// src/pages/FabricDashboard.js
import { useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Utils
import useLanguage from "../../utils/useLanguage";
import { UserAuth } from "../../utils/AuthContext";

// Components
import DashboardSection from "../../components/DasboardSection";
import CustomButton from "../../components/CustomButton";
import PageWrapper from "../../components/PageWrapper";

export default function AddOrder() {
  const { t } = useTranslation("general");
  const { currentDirection } = useLanguage();
  const { userData } = useContext(UserAuth);

  return (
    <PageWrapper
      style={{ direction: currentDirection }}
      title={t("addOrder")}
      withBackButton
    >
      <DashboardSection title={"orders"}>
        <div className="o-grid o-grid--auto-columns_xsmall">
          <CustomButton
            title={t("addBookOrder")}
            variant="blank"
            elementType={Link}
            to="/add-book-order"
          />
          <CustomButton
            title={t("addUniformOrder")}
            variant="blank"
            elementType={Link}
            to="/add-uniform-order"
          />
        </div>
      </DashboardSection>
    </PageWrapper>
  );
}
